/**
 * Shared `TableFilterSelector` chrome, wired to the `filters.*` and `common.resultsCountPlural` i18n keys.
 *
 * These labels are the same sentence in every list that mounts the Filtrer panel, so
 * they live here rather than being restated per module. OPAL falls back to hard-coded
 * English for any label a consumer omits, and none of these appears until the user
 * searches or ticks something — so an omission ships untranslated chrome that a quick
 * pass over the panel never shows (R29, same failure mode as R69's column settings).
 *
 * Spread it: `v-bind="filterSelectorLabels"`, which keeps the set complete by construction.
 * Module-specific labels (placeholders, Back/Apply) stay at the call site.
 */
export function buildFilterSelectorLabels(t) {
    return {
        // Reuses the advanced-filter field picker's wording: same question, same answer, and
        // FilterFieldSelect already states it as a whole sentence rather than a prefix.
        noFieldResultsLabel: t("filters.noFieldResults"),
        selectedCountLabel: (selected, total) => t("filters.selectedCount", { selected, total }),
        resultsCountLabel: (count) => t("common.resultsCountPlural", count),
        searchClearLabel: t("common.clearSearch"),
    };
}
